<div fxLayout="column">
  @for (bank of banks; track bank) {
    <div fxLayout="column" class="bank">
      <span class="bold">Bank</span>
      <span class="name">{{bank}}</span>
      <div fxFlex="auto" fxLayout="row" fxLayoutAlign="space-between start" class="bold header">
        <div fxFlex="55" fxLayout="row" fxLayoutAlign="start start">
          <span fxFlex="33">Vendor Name</span>
          <span fxFlex="33">Payable Number</span>
          <span fxFlex="33">Description</span>
        </div>
        <div fxFlex="45" fxLayout="row" fxLayoutAlign="end start" class="bold numeric">
          <span fxFlex="25">Invoice Date</span>
          <span fxFlex="25">Payable Due Date</span>
          <span fxFlex="25">Discount Amount</span>
          <span fxFlex="25">Payable Amount</span>
        </div>
      </div>
      @for (vendor of getVendors(bank); track vendor) {
        <div fxLayout="column" class="vendor">
          @for (payment of getPayments(vendor); track payment; let isFirstPayment = $first) {
            <div fxLayout="column">
              @for (invoice of payment.Payables; track invoice; let isFirstInvoice = $first) {
                <div fxFlex="auto" fxLayout="column" class="mt10">
                  <div fxFlex="auto" fxLayout="row" fxLayoutAlign="space-between start">
                    <div fxFlex="55" fxLayout="row" fxLayoutAlign="start start">
                      @if (isFirstPayment && isFirstInvoice) {
                        <span fxFlex="33">{{payment.Vendor}}</span>
                      }
                      @if (!(isFirstPayment && isFirstInvoice)) {
                        <span fxFlex="33"></span>
                      }
                      <span fxFlex="33">{{invoice.Number}}</span>
                      <span fxFlex="33">{{invoice.Description}}</span>
                    </div>
                    <div fxFlex="45" fxLayout="row" fxLayoutAlign="end start" class="numeric">
                      <span fxFlex="25">{{invoice.PayableDate | date:'M/d/yyyy'}}</span>
                      <span fxFlex="25">{{invoice.DueDate | date:'M/d/yyyy'}}</span>
                      <span fxFlex="25">{{invoice.DiscountAmount | currency}}</span>
                      <span fxFlex="25">{{invoice.TotalAmount | currency}}</span>
                    </div>
                  </div>
                </div>
              }
            </div>
          }
          <div fxFlex="auto" fxLayout="row" fxLayoutAlign="space-between start">
            <div fxFlex="55"></div>
            <div fxFlex="45" fxLayout="column">
              <div fxLayout="row" fxLayoutAlign="end start" class="numeric bold header">
                <span fxFlex="25">Payment Type</span>
                <span fxFlex="25">Payment Number</span>
                <span fxFlex="25">Date</span>
                <span fxFlex="25">Amount</span>
              </div>
              @if (!hasPayments(getPayments(vendor))) {
                <div class="numeric row">
                  No Payments
                </div>
              }
              @for (payment of getPayments(vendor); track payment) {
                @if (hasPayments(getPayments(vendor))) {
                  <div fxLayout="row" fxLayoutAlign="end start" class="numeric row">
                    <span fxFlex="25">{{payment.PaymentType}}</span>
                    <span fxFlex="25">{{payment.PaymentNumber}}</span>
                    <span fxFlex="25">{{payment.PaymentDate | date:'M/d/yyyy'}}</span>
                    <span fxFlex="25">{{payment.TotalPayment | currency}}</span>
                  </div>
                }
              }
              <mat-divider></mat-divider>
            </div>
          </div>
        </div>
      }
      <mat-divider></mat-divider>
    </div>
  }

  <div fxFlex="auto" fxLayout="column" class="summary">

    <h3>Payment Summary</h3>

    <div fxLayout="column" class="center">
      <div fxFlex="50" fxLayout="row">
        <span fxFlex="30" class="bold">Type</span>
        <span fxFlex="20" class="bold numeric">Count</span>
        <span fxFlex="50" class="bold numeric">Total Amount</span>
      </div>

      @if (!hasTotalPayments) {
        <div fxFlex="auto" class="numeric row">
          No Payments
        </div>
      }

      @if (hasTotalPayments) {
        @for (total of totals; track total) {
          <div fxLayout="row" fxLayoutAlign="space-between start" class="row">
            <span fxFlex="30">{{total.key}}</span>
            <span fxFlex="20" class="numeric">{{total.value.count}}</span>
            <span fxFlex="50" class="numeric">{{total.value.amount | currency}}</span>
          </div>
        }
      }

      <mat-divider></mat-divider>
    </div>

    @if (grandTotal > 0) {
      <div class="grandTotal">
        <div fxLayout="row" fxLayoutAlign="space-between start">
          <span fxFlex="30" class="bold">Totals:</span>
          <span fxFlex="20" class="numeric">{{count}}</span>
          <span fxFlex="50" class="numeric">{{grandTotal | currency}}</span>
        </div>
      </div>
    }
  </div>
</div>
